import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { ScheduleItem } from "types/response/schedule";
import { formatTime } from "utils/time";
import { dayMap, getCleaningSettingDisplayLabels } from "./helper";

type ScheduleCardProps = {
  schedule: ScheduleItem;
  mapName: string;
  exSrvCode: string;
  deleteAction: () => void;
  editAction: () => void;
};

export const ScheduleCard = ({
  schedule,
  mapName,
  exSrvCode,
  editAction,
  deleteAction,
}: ScheduleCardProps) => {
  const displayTime = formatTime(schedule.hour, schedule.minute);
  const cleaningSettings = getCleaningSettingDisplayLabels({
    code: exSrvCode,
    settings: schedule.cleaningSettings,
  });
  return (
    <Card variant="outlined">
      <CardContent>
        <Box>
          <Typography variant="h4">{`${
            dayMap[schedule.dayOfWeek]
          } ${displayTime}`}</Typography>
          <Typography variant="h6" color="text.secondary">
            {mapName}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">
            {schedule.scheduleName}
          </Typography>
        </Box>
        <Box mt={1}>
          <Box display={"flex"} alignItems={"center"} gap={1}>
            <CleaningServicesIcon
              sx={{ color: "text.secondary" }}
              fontSize="small"
            />
            <Typography variant="subtitle2" color="text.secondary">
              清掃設定
            </Typography>
          </Box>
          <Box>
            {cleaningSettings.map((cs, i) => {
              if (cs.hide) return null;
              return (
                <Typography key={i} variant="body2" color="text.secondary">
                  {`${cs.type}: ${cs.value}`}
                </Typography>
              );
            })}
          </Box>
        </Box>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Stack spacing={2} direction={"row"}>
          <Button
            color="error"
            variant="outlined"
            startIcon={<DeleteIcon />}
            onClick={deleteAction}
          >
            削除
          </Button>
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={editAction}
          >
            編集
          </Button>
        </Stack>
      </CardActions>
    </Card>
  );
};
